// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_Billing360GraceRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_Billing360GraceRow — one franchises_grace_periods row in the
 * billing-360 grace_windows list.
 *
 * Datetime fields are ISO-8601 UTC strings (controller converts GMT-3).
 */
import { registerContract } from './validate'

export interface Subscriptions_Billing360GraceRow {
id: number
subscription_id?: number
plan_id?: number
starts_at?: string
ends_at?: string
source?: string
granted_by?: string
reason?: string
revoked_at?: string
}

registerContract('Subscriptions_Billing360GraceRow', {
  id:              { type: 'number',  required: true },
  subscription_id: { type: 'number',  required: false },
  plan_id:         { type: 'number',  required: false },
  starts_at:       { type: 'string',  required: false },
  ends_at:         { type: 'string',  required: false },
  source:          { type: 'string',  required: false },
  granted_by:      { type: 'string',  required: false },
  reason:          { type: 'string',  required: false },
  revoked_at:      { type: 'string',  required: false },
})
